import { useEffect, useState } from "react";
import CustomButton from "../../../../../components/inputs/button";
import Loader from "../../../../../components/loader/loader";
import Snackbar from "../../../../../components/snackbar/snackbar";
import "./dialog.css";
import TextField from "../../../../../components/inputs/textfield";
import { update_floor_name } from "../../../admin.api";

const Dialog = ({ open, handleClose, formData: initialData }) => {
  const [formData, setFormData] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData({});
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) handleClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // if (!formData.floor_name) {
    //   setSnackMessage("Floor Name is required");
    //   setIsSnackError(true);
    //   setSnackOpen(true);
    //   return;
    // }

    setIsActive(true);

    const payload = {
      floor_name: formData.floor_name,
      floor_no: formData.floor_no,
    };

    update_floor_name(formData.id, payload)
      .then((res) => {
        setSubmitted(true);
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
      })
      .catch((err) => {
        setSubmitted(false);
        setSnackMessage(err.response?.data?.message || "An error occurred");
        setIsSnackError(true);
        setSnackOpen(true);
      })
      .finally(() => setIsActive(false));
  };

  if (!open) return null;

  return (
    <div className="overlay">
      <Loader open={isActive} />
      <div className="big-dia dialog">
        <Snackbar
          message={snackMessage}
          error={isSnackError}
          open={snackOpen}
          close={snackbarClose}
        />
        <div className="row">
          <div className="flexDisplay">
            <div className="diaTitleCon">Edit Floor Name</div>

            <div className="dia-close" onClick={handleClose}>
              <div className="diaCloseCon">
                <div className="diaClose">&#10005;</div>
              </div>
            </div>
          </div>
          <div className="tilebar d-flex justify-content-start">
            <hr />
          </div>
          <form onSubmit={handleSubmit}>
            <div className="book-form">
              <div className="col-12">
                <TextField
                  label="Building Name"
                  name="floor_name"
                  variant="outlined"
                  type="text"
                  value={formData?.floor_name ?? ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-12">
                <TextField
                  label="Floor No"
                  name="floor_no"
                  variant="outlined"
                  type="text"
                  value={formData?.floor_no ?? ""}
                  onChange={handleChange}
                />
              </div>

              <div className="col-12">
                <CustomButton
                  label="Update"
                  disabled={submitted}
                  onClick={handleSubmit}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Dialog;
